import React, { useState} from "react";
import EditModal from "../../EditSite/EditModal";
import PowerAppSolutionEditModal from "../../EditSite/PowerAppSolutionEditModal";
import { PowerAppBaseType } from "../../../GlobalConst/globalEnums";
import { PrimaryButton } from '@fluentui/react';
import { renderDate } from "../../../helpers/HelperMethods";

const PowerAppRecertificationTask = ({ app, solution, task, getCallback, refresh }) => {
    
    const [showAppModal, setShowAppModal] = useState(false);
    const [showSolutionModal, setShowSolutionModal] = useState(false);
    const [solutionId, setSolutionId] = useState(null);

    const handleShowSolutionModal = (solutionId) => {
        setShowAppModal(false);
        setSolutionId(solutionId);
        setShowSolutionModal(true);
    };

    const callback = (item) => {
        if (getCallback) {
            switch (item.type) {
                case PowerAppBaseType.powerApp:
                    getCallback(item, 'powerApps')
                    break
                case PowerAppBaseType.flow:
                    getCallback(item, 'flows')
                    break
                default: 
                    getCallback(item, 'powerAppSolutions')
                    return
            }   
        }
    }

    const recertify = () => {
        if (app) {
            setShowAppModal(true)
        } else if (solution) {
            handleShowSolutionModal(solution.id)
        }
    }

    const getObjectType = (app) => {
        return  app 
                ? (app.type === PowerAppBaseType.flow
                    ? 'Power Automate'
                    : app.appType)
                : 'Power Platform Solution'

    }

    return (
        <div style={containerStyles}>
            <div style={containerStyles}>
                <div style={detailsStyle}>
                    <p>Dear {task.approver.displayName},</p>
                    <p>Your {getObjectType(app)} will expire on <b>{renderDate(task.expirationDate)}</b>.</p>
                    <p>If not confirmed as still needed before this date, it will be <b>deleted.</b></p>
                </div>
                <PrimaryButton styles={btnStyle} onClick={recertify} text='Recertify' />
            </div>
            <EditModal
                onCloseModal={() => setShowAppModal(false)}
                isModalOpened={showAppModal}
                itemId={app && app.id}
                callBack={callback}
                isPowerApp={true}
                showSolutionModal={handleShowSolutionModal}
                isEditable={true}
                refreshCallback={refresh}
            />
            <PowerAppSolutionEditModal
                solutionId={solutionId}
                showModal={showSolutionModal}
                callback={(item) => callback(item)}
                onCloseModal={() => setShowSolutionModal(false)}
                refresh={refresh}
            />
        </div>
    );
}

const containerStyles = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flex: 1
}

const btnStyle = {
    root: {
        width: "100%",
        borderRadius: 0
    }
}

const detailsStyle = {
    padding: '0px 12px',
    fontSize: '14px',
    overflow: 'auto',
    lineHeight: '20px',
    overflowWrap: "break-word"
}

export default PowerAppRecertificationTask


// WEBPACK FOOTER //
// ./src/components/ManageCenter/ChangeValues/PowerAppRecertificationTask.js